import { PRODUCT_IDS } from '@adsk/alloy-provider';

type ProductIdsType = typeof PRODUCT_IDS;

export type ProductTitleKey = ProductIdsType[keyof ProductIdsType];

const PRODUCT_TITLES = {
  [PRODUCT_IDS.MODEL_COORDINATION]: 'Model Coordination',
  [PRODUCT_IDS.DESIGN_COLLABORATION]: 'Design Collaboration',
  [PRODUCT_IDS.QUANTIFY]: 'Quantify',
  [PRODUCT_IDS.TAKEOFF]: 'Takeoff',
  [PRODUCT_IDS.COST]: 'Cost',
  [PRODUCT_IDS.INSIGHT]: 'Insight',
  [PRODUCT_IDS.BUILD]: 'Build',
  [PRODUCT_IDS.DOCS]: 'Data Management',
  [PRODUCT_IDS.ACCOUNT_ADMINISTRATION]: 'Hub Administration',
  [PRODUCT_IDS.HUB_ADMINISTRATION]: 'Hub Administration',
  [PRODUCT_IDS.PROJECT_ADMINISTRATION]: 'Project Administration',
  [PRODUCT_IDS.AUTOSPECS]: 'AutoSpecs',
  [PRODUCT_IDS.BUILDING_CONNECTED]: 'BuildingConnected',
  [PRODUCT_IDS.FORMA_DESIGN]: 'Design',
  [PRODUCT_IDS.DATUM]: 'Datum',
} as const;

export type ProductTitlesValues =
  (typeof PRODUCT_TITLES)[keyof typeof PRODUCT_TITLES];

const getProductTitle = (key: ProductTitleKey): ProductTitlesValues => {
  return PRODUCT_TITLES[key];
};

export default getProductTitle;
